export function initCityMaps() {
    const blocks = [].slice.apply(document.querySelectorAll('[data-block="CityMap"]'));
    blocks.forEach(initCityMapInstance);
}

/**
 *
 * @param {HTMLElement} root
 */
export function initCityMapInstance(root) {

    const areasButtons = [].slice.apply(root.querySelectorAll('.areasButtons .-button'));
    const map = L.map(root.querySelector('.-map'), {
        zoomControl: false,
        attributionControl: false,
    }).setView([51.505, -0.09], 13);

    L.tileLayer(`https://api.mapbox.com/styles/v1/westart/{styleId}/tiles/256/{z}/{x}/{y}?access_token={accessToken}`, {
        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        accessToken: process.env.MIX_MAPBOX_TOKEN,
        styleId: process.env.MIX_MAPBOX_STYLE,
    }).addTo(map);

    // map.dragging.disable();
    // map.touchZoom.disable();
    // map.doubleClickZoom.disable();
    map.scrollWheelZoom.disable();
    map.getContainer().setAttribute('id', root.dataset.id);

    let markers = [];
    areasButtons.map((el, index) => {
        const lat = el.dataset.lat;
        const lng = el.dataset.lng;
        const title = el.dataset.title;
        const permalink = el.href;

        const mapMarker = L.divIcon({
            className: 'leaflet-marker',
            iconSize: [8, 4],
        });

        let marker = L.marker([lat, lng], {
            interactive: false,
            icon: mapMarker,
        }).addTo(map);

        let popup = new L.Popup({
            autoClose: false,
            closeOnClick: false,
            closeButton: false,
        }).setContent(`<a href="${permalink}" aria-hidden="true" tabindex="-1" class="map-popup" data-id="${index}">${title}</a>`);

        marker.bindPopup(popup).openPopup();
        markers.push(marker);

        const markerElement = marker.getElement();
        if (markerElement) {
            markerElement.removeAttribute("tabindex");
        }

        map.getContainer().addEventListener('keydown', (event) => {
            const popupLinks = map.getContainer().querySelectorAll('.map-popup');
            const firstFocusableElement = popupLinks[0];
            const lastFocusableElement = popupLinks[popupLinks.length - 1];

            if (event.key === 'Enter') {
                popupLinks.forEach((el, index) => {
                    if (index === 0) {
                        el.focus();
                    }
                    el.setAttribute('tabindex', '0');
                });
            }

            if (event.key === 'Tab' || event.keyCode === 9) {
                if (event.shiftKey) {
                    if (document.activeElement === firstFocusableElement) {
                        lastFocusableElement.focus();
                        event.preventDefault();
                    }
                } else {
                    if (document.activeElement === lastFocusableElement) {
                        firstFocusableElement.focus();
                        event.preventDefault();
                    }
                }
            }
            if (event.key === 'Escape') {
                map.getContainer().focus();
                popupLinks.forEach((el, index) => {
                    el.setAttribute('tabindex', '-1');
                });
            }
        });

        popup.getElement().dataset.id = index;
    });

    // fit map to markers
    const group = new L.featureGroup(markers);
    map.fitBounds(group.getBounds(), {
        padding: [50, 50],
        maxZoom: 14,
    });

    // highlight popups and buttons
    const popups = [].slice.apply(root.querySelectorAll('.leaflet-popup'));

    const highlitable = areasButtons.concat(popups);

    highlitable.forEach(handleHighlights);

    function handleHighlights(el) {
        el.addEventListener('mouseover', () => {
            highlitable.filter(btn => {
                return btn.dataset.id === el.dataset.id;
            }).map((btn) => {
                btn.classList.add('is--active');
            });
        });

        el.addEventListener('mouseout', () => {
            el.classList.remove('is--active');
            highlitable.filter(btn => {
                return btn.dataset.id === el.dataset.id;
            }).map((btn) => {
                btn.classList.remove('is--active');
            });
        });
    }

    const scrollButton = root.querySelector('.scroll-to-preview');
    if (scrollButton) {
        scrollButton.addEventListener('click', (event) => {
            event.preventDefault();
            const previewBlock = document.querySelector('.rb-areasPreview');

            if (!previewBlock) {
                return;
            }

            jQuery('html, body').animate({
                scrollTop: jQuery(previewBlock).offset().top - 140,
            }, 1000);
        });
    }
}
